import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import { useParams } from "react-router-dom";
import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import ReportTableSkeleton from "../components/loader/ReportTableSkeleton";
import NoDataFound from "../components/NoDataFound";
import AddEditPerspectiveBoardmember from "../components/popup/AddEditPerspectiveBoardmember";
import DeletePopup from "../components/DeletePopup";
import toastr from "toastr";

const PerspectiveBoardMember = () => {
  const { id } = useParams();
  if (id) {
    setTitle("Succession Now | Edit Boardroom");
  } else {
    setTitle("Succession Now | Add Boardroom");
  }
  const { t } = useTranslation();

  const [isOpenPopup, setIsOpenPopup] = useState({
    open: false,
    data: null,
  });
  const [loading, setLoading] = useState(false);
  const [perspectives, setPerspectives] = useState([]);
  const [enabledDeletePopup, setenabledDeletePopup] = useState({
    isOpen: false,
    data: null,
  });
  const [actionValue, setActionValue] = useState({});
  const params = new URLSearchParams(window.location.search);
  const paramsValue = params.get("user");

  const loadList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await postData("perspective-board-member/list", {
        sortQuery: { created_at: 1 },
        type: "boardmember",
        user_id : paramsValue ? paramsValue : "",
      });

      if (result.data) {
        setPerspectives(result.data);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadList();
  }, [loadList]);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "delete") {
      const loadDeleteRecord = async () => {
        try {
          const deleteData = await postData("prospective-board-member/delete", {
            id: actionValue?.row_id,
          });
          if (deleteData.data) {
            //setPerspectives((member) => member.filter((item) => item._id !== actionValue.row_id));
            loadList();
          } else {
            toastr.error(deleteData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      loadDeleteRecord();
    }
  }, [actionValue]);
  
  return (
    <>
      <div className="relative d-flex justify-between items-center mb-4">
        <div className="text-3xl text-slate-800 font-bold">
          {t("perspective_board_member_candidates")}
        </div>

        <div className="flex justify-end items-end space-x-2">
          <div
            className="sm:ml-auto flex justify-end items-center"
            data-tooltip-id={`button${1}`}
            data-tooltip-place="bottom"
          >
            <Button
              buttonType={"button"}
              buttonIcon={"fa-light fa-plus"}
              buttonIconPosition={"left"}
              buttonLabel={t("add")}
              buttonHasLink={false}
              functions={() => {
                setIsOpenPopup({
                  open: true,
                  data: null,
                });
              }}
            />
            <Tooltip
              id={`button${1}`}
              className="!text-xs !bg-teal-500 z-50 rounded py-3 px-6 !opacity-100"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">
                      Add New Perspective Board Member
                    </div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      </div>
      <div className="w-full overflow-auto scroll-smooth scrollbar min-h-[480px]">
        <table className="min-w-max w-full table-auto">
          <tbody className="text-slate-700 text-sm font-light bg-slate-300 divide-y divide-slate-200">
            <tr className="text-white font-bold text-sm leading-none bg-slate-900 !border-none">
              <th className="py-4 px-2 text-left max-w-[240px] z-10">Name</th>
              <th className="py-4 px-2  max-w-[240px] z-10">
                Level of Education
              </th>
              <th className="py-4 px-2  max-w-[240px] z-10">Field of Study</th>
              <th className="py-4 px-2  max-w-[240px] z-10">
                Industry Experience
              </th>
              <th className="py-4 px-2  max-w-[240px] z-10">Action</th>
            </tr>
            {perspectives && perspectives.length > 0 ? (
              perspectives.map((items, index) => (
                <tr className="bg-white" key={index}>
                  <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-top">
                    {items?.first_name + " " + items?.last_name}
                    {/* <span className="block text-xs font-bold leading-tight text-teal-500">{items?.position_details ? items?.position_details[0]?.short_name : "N/A"}</span> */}
                  </td>
                  <td
                    key={index}
                    className="py-3 px-2 text-left max-w-[240px] align-top"
                  >
                    <div className="relative flex justify-center text-xs font-medium text-slate-700 bg-white py-2 px-3 border border-slate-200 rounded">
                      {items?.education_details
                        ? items?.education_details?.name
                        : "N/A"}
                    </div>
                  </td>
                  <td
                    key={index}
                    className="py-3 px-2 text-left max-w-[240px] align-top"
                  >
                    <div className="relative flex justify-center text-xs font-medium text-slate-700 bg-white py-2 px-3 border border-slate-200 rounded">
                      {items?.study_details
                        ? items?.study_details?.name
                        : "N/A"}
                    </div>
                  </td>
                  <td
                    key={index}
                    className="py-3 px-2 text-left max-w-[240px] align-top"
                  >
                    <div className="relative flex flex-col justify-center text-xs font-medium text-slate-700 bg-white py-2 px-3 border border-slate-200 rounded">
                      <div className="relative before:content-[''] before:absolute before:top-1.5 before:left-0 before:w-1 before:h-1 before:bg-black before:rounded-full pl-4">
                        {items?.industry_details
                          ? items?.industry_details?.name
                          : "N/A"}
                      </div>
                      <div className="relative before:content-[''] before:absolute before:top-1.5 before:left-0 before:w-1 before:h-1 before:bg-black before:rounded-full pl-4">
                        {items?.industry_one_details
                          ? items?.industry_one_details?.name
                          : "N/A"}
                      </div>
                      <div className="relative before:content-[''] before:absolute before:top-1.5 before:left-0 before:w-1 before:h-1 before:bg-black before:rounded-full pl-4">
                        {items?.industry_two_details
                          ? items?.industry_two_details?.name
                          : "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-top">
                    <div className="flex-shrink-0 flex items-center justify-center gap-2 pt-2">
                      <div
                        className="cursor-pointer p-1 rounded  transition"
                        onClick={() => {
                          setIsOpenPopup({ open: true, data: items });
                        }}
                      >
                        <i className="fa-regular fa-pen text-teal-500 hover:text-teal-700 text-base"></i>
                      </div>
                      <div
                        className="cursor-pointer p-1 rounded  transition"
                        onClick={() => {
                          setenabledDeletePopup({
                            isOpen: true,
                            data: items?._id,
                          });
                        }}
                      >
                        <i className="fa-solid fa-trash text-rose-500 hover:text-rose-700 text-base"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="!border-none">
                {loading ? (
                  <td className="p-0 text-left" colSpan={11}>
                    <div className="space-y-5">
                      <ReportTableSkeleton />
                      <ReportTableSkeleton />
                    </div>
                  </td>
                ) : (
                  <td className="text-left p-0" colSpan={11}>
                    <NoDataFound label={t("no_data_found")} />
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <AddEditPerspectiveBoardmember
        isOpen={isOpenPopup?.open}
        setIsOpen={setIsOpenPopup}
        loadList={loadList}
        data={isOpenPopup?.data}
      />
      {enabledDeletePopup && (
        <DeletePopup
          isOpen={enabledDeletePopup?.isOpen}
          setIsOpen={(val) => setenabledDeletePopup({ isOpen: val })}
          currentId={enabledDeletePopup?.data}
          getActionValue={(obj) => {
            setActionValue(obj);
            setenabledDeletePopup({ isOpen: false });
          }}
        />
      )}
    </>
  );
};

export default PerspectiveBoardMember;
